import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { MonumentDto } from '../../../dtos/monumentDto';
import { GlobalDataService } from '../../../shared-services/global-data.service';
import { MonumentEntityService } from './monument-entity.service';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-monument-entity',
    templateUrl: './monument-entity.component.html',
    styleUrls: ['./monument-entity.component.scss']
})
export class MonumentEntityComponent implements OnInit {

    @Input()
    monument: any;

    @Input()
    siteId: any;

    flowLoading: boolean;

    @Input()
    hiddenButtons: {
        addMonument?: boolean,
        deleteMonument?: boolean
    };

    @Output()
    monumentSave: EventEmitter<any> = new EventEmitter<any>();

    public languages: any[];

    constructor(public globalData: GlobalDataService, private monumentEntityService: MonumentEntityService) {
        this.languages = this.globalData.globalData.languages;
        if (!this.monument) {
            this.monument = new MonumentDto(this.siteId);
            this.languages.forEach((language) => {
                this.monument.monumentTranslations.push({
                    id: null,
                    monumentId: null,
                    language: language,
                    name: '',
                    shortDescription: '',
                    description: '',
                    listName: '',
                    audioPath: '',
                    extraDescription: ''
                })
            });
        }
    }

    ngOnInit(): void {
    }

    createMonument() {

    }

    saveMonument() {
        this.monument.siteId = this.siteId;
        this.monumentEntityService.saveToBackend(this.monument)
            .subscribe((value) => {
                this.monument = Object.assign({}, value);
                this.monumentSave.emit(value);
            })
    }

    deleteSite() {

    }

}
